export const MAX_DATETIME_SEGMENT = 10 * 60 * 1000

export const IM_PAGE_SIZE = 30

export const DEFAULT_HEADIMG = 'https://cdn.vip-wifi.com/fangchan/img/personal_center/default-headimg.png'

export const LOGIN_STATUS = {
    DONE: 'done',
    DOING: 'doing',
    NONE: 'none'
}

export const PAGE_TO_KEY = {
    '/index/main': '首页',
    '/building/value_analysis/main': '楼盘价值分析报告',
    '/building/main': '楼盘详情',
    '/building/comments/main': '楼盘评论',
    '/consultants/main': '置业顾问列表',
    '/consultants/filter/main': '楼盘置业顾问',
    '/consultants/card/main': '名片',
    '/personal_center/main': '个人中心',
    '/chat_list/main': '咨询',
    '/messages/main': '消息首页',
    '/house_circles/main': '房友圈',
    '/packageA/web_article/main': '房友圈文章',
    '/activity_a/thematic/main': '楼盘主题页',
    '/building/business': '商业楼盘',
    '/building/price/main': '一房一价',
    '/building/visit_building/main': '踩盘',
    '/building/img_preview/main': '楼盘图片/户型图',
    '/building/info/main': '楼盘信息页',
    '/building/material/main': '楼盘购房资料',
    '/building/planar_graph/main': '楼盘总评图',
    '/building/vr': '楼盘VR线上售楼部',
    '/building/comments/detail/main': '楼盘评论',
    '/chat_list/chat/main': '聊天咨询页'
}